import modals from '@my/store/modals'
import auth from '@my/authentication'
import config from '@/config'
import store from '@/store'

export default {
  async query (query, variables = {}, showErrors = true, isSahet = true, returnError = false) {
    const company = store.state.company

    const response = await fetch(isSahet ? config.GRAPHQL.uri : config.GRAPHQL.uri_bassica, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json; charset=UTF-8',
        token: auth.getToken() || '',
        company
      },
      body: JSON.stringify({ query, variables })
    })
      .catch(error => {
        if (showErrors) modals.showMessage({ message: error, type: 'error' })
      })

    if (response) {
      const data = await response.json()
      if (data.errors && data.errors[0]) {
        if (showErrors) modals.showMessage({ message: data.errors[0].message, type: 'error' })
        if (returnError) return { error: data.errors[0].message }
      }

      if (data.data) return data
    } else {
      if (showErrors) modals.showMessage({ message: 'No hubo respuesta del servidor', type: 'error' })
    }
  },

  async mutate (query, variables = {}, showErrors = true, errors = [], body) {
    const errorMutation = {}

    let requestData

    if (!body) {
      requestData = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json; charset=UTF-8',
          token: auth.getToken() || ''
        },
        body: JSON.stringify({ query, variables })
      }
    } else {
      requestData = {
        method: 'POST',
        body
      }
    }

    const response = await fetch(config.GRAPHQL.uri, requestData)
      .catch(error => {
        if (showErrors) modals.showMessage({ message: error, type: 'error' })
        errors.push(error)
        errorMutation.error = error
      })

    if (response) {
      const data = await response.json()

      if (data.errors && data.errors[0]) {
        if (showErrors) modals.showMessage({ message: data.errors[0].message, type: 'error' })
        errorMutation.error = data.errors[0].message
        errors.push(data.errors[0].message)
        if (!showErrors) return errorMutation
      } else {
        if (data.data) return data
      }
    } else {
      if (showErrors) modals.showMessage({ message: 'No hubo respuesta del servidor', type: 'error' })
      errors.push('No hubo respuesta del servidor')
      errorMutation.error = 'No hubo respuesta del servidor'
    }

    if (errorMutation.error && !showErrors) return errorMutation
  },

  async mutateImage (query, variables = {}, showErrors = true, errors = [], blob, fileName) {
    const errorMutation = {}

    variables.token = auth.getToken() || ''

    const formData = new FormData()
    formData.append('operations', JSON.stringify({ query, variables }))
    formData.append('map', JSON.stringify({ 0: ['variables.image'] }))
    formData.append('0', blob, fileName)

    const response = await fetch(config.GRAPHQL.uri, {
      method: 'POST',
      body: formData
    })
      .catch(error => {
        if (showErrors) modals.showMessage({ message: error, type: 'error' })
        errors.push(error)
        errorMutation.error = error
      })

    if (response) {
      const data = await response.json()

      if (data.errors && data.errors[0]) {
        if (showErrors) modals.showMessage({ message: data.errors[0].message, type: 'error' })
        errorMutation.error = data.errors[0].message
        errors.push(data.errors[0].message)
        if (!showErrors) return errorMutation
      } else {
        if (data.data) return data
      }
    } else {
      if (showErrors) modals.showMessage({ message: 'No hubo respuesta del servidor', type: 'error' })
      errors.push('No hubo respuesta del servidor')
      errorMutation.error = 'No hubo respuesta del servidor'
    }

    if (errorMutation.error && !showErrors) return errorMutation
  }
}



//////////////////
// WEBPACK FOOTER
// ./my_modules/graphql/index.js
// module id = null
// module chunks = 